import { render, staticRenderFns } from "./NewsDetailScreen.vue?vue&type=template&id=774b5a28"
import script from "./NewsDetailScreen.vue?vue&type=script&lang=ts"
export * from "./NewsDetailScreen.vue?vue&type=script&lang=ts"
import style0 from "./NewsDetailScreen.vue?vue&type=style&index=0&id=774b5a28&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports